<template>
  <div>
    <div
      v-if="searchShow"
      @click="searchShow = false"
      class="fixed z-40 inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
    ></div>

    <div
      class="header-title w-full flex-1 border-b  p-2 flex items-center justify-between"
    >
      <div class="flex items-center space-x-2  justify-start">
        <vk-icon-button
          class="back-icon"
          @click="$router.push('/')"
          icon="home"
        ></vk-icon-button>
        <vk-icon-button
          class="back-icon"
          @click="$root.back()"
          icon="chevron-left"
        ></vk-icon-button>
        <vk-icon-button
          class="back-icon"
          v-if="favorite"
          @click="favoriteAdd(favorite)"
          icon="heart"
        ></vk-icon-button>
        <vk-icon-button
          class="back-icon"
          v-if="favorite"
          @click="nextLead()"
          icon="chevron-right"
        ></vk-icon-button>
        <h2 class="text-xl font-bold my-0">{{ title }}</h2>
      </div>

      <div v-if="searchShow == false" class=" ">
        <form
          class="flex items-center"
          @submit="searchSubmit()"
          action="javascript:void(0)"
        >
          <div style="margin-top:3px;margin-left: 10px; position: absolute">
            <transition name="fade">
              <vk-icon icon="close" v-if="searchValue" @click="searchClear()" />
              <vk-icon v-else @click="searchSubmit()" icon="search" />
            </transition>
          </div>

          <input
            class="w-10 md:w-72 rounded-lg border-gray-200 text-xs border p-2"
            @click="showSearchSet()"
            style="margin-right: 0px; text-indent: 35px"
            type="search"
            placeholder="Aranacak kelime, kısayol ctrl+k"
          />
        </form>
      </div>
    </div>

    <div v-if="searchShow">
      <div class="fixed inset-0 z-40 overflow-y-auto">
        <div
          class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0"
        >
          <div
            class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8
             sm:w-full sm:max-w-lg"
          >
            <div class="bg-white  ">
              <div class=" sm:items-start">
                <div
                  class="flex p-2 bg-gray-50 border-b items-center justify-between space-x-2"
                >
                  <div>
                    <svg class="w-8 h-8" viewBox="0 0 32 32">
                      <path
                        fill="currentColor"
                        d="m29 27.586l-7.552-7.552a11.018 11.018 0 1 0-1.414 1.414L27.586 29ZM4 13a9 9 0 1 1 9 9a9.01 9.01 0 0 1-9-9Z"
                      />
                    </svg>
                  </div>
                  <input
                    class="border-gray-50 border focus:border-transparent focus:ring-0  ring-0 w-full text-xl  p-2 bg-gray-50   "
                    v-model="searchValue"
                    type="text"
                    @keyup.enter="keyEnter($event)"
                    id="rootsearch"
                    placeholder="Aranacak kelime"
                  />

                  <div @click="searchOnlyClear()">
                    <svg class="w-8 h-8" viewBox="0 0 24 24">
                      <path
                        fill="currentColor"
                        d="M6.4 19L5 17.6l5.6-5.6L5 6.4L6.4 5l5.6 5.6L17.6 5L19 6.4L13.4 12l5.6 5.6l-1.4 1.4l-5.6-5.6Z"
                      />
                    </svg>
                  </div>
                </div>

                <div class="flex p-2">
                  <div v-if="lead_id > 0" class="flex-1">
                    <div
                      class="border-b flex mb-2  p-2 items-center justify-between "
                      :key="search.id"
                      v-for="search in searchResults"
                      v-if="search.id == lead_id"
                    >
                      <span @click="lead_id = 0">
                        <svg class="w-6 h-6" viewBox="0 0 24 24">
                          <path
                            fill="currentColor"
                            d="M16 22L6 12L16 2l1.775 1.775L9.55 12l8.225 8.225Z"
                          />
                        </svg>
                      </span>

                      <div @click="setLeadId(search.id)">{{ search.name }}</div>
                      <div class="flex space-x-2 items-center">
                        <div>{{ $root.getVal(15, search.agent_id) }}</div>

                        <a target="_blank" :href="'/leadDetail/' + search.id"
                          ><span style="font-size: 11px" class="green-button"
                            >DETAY</span
                          ></a
                        >
                      </div>
                    </div>

                    <Notes
                      class="w-full"
                      table="crm_notes"
                      field="leadId"
                      selectedStatus="1"
                      :id="lead_id"
                    />
                  </div>
                  <div v-else class="flex-1">
                    <div
                      v-if="searchResults"
                      class="border-b flex cursor-pointer p-2 items-center justify-between "
                      :key="search.id"
                      v-for="search in searchResults"
                    >
                      <div @click="setLeadId(search.id)">{{ search.name }}</div>
                      <div class="flex justify-between items-center space-x-2">
                        <div>{{ $root.getVal(15, search.agent_id) }}</div>

                        <a target="_blank" :href="'/leadDetail/' + search.id"
                          ><span style="font-size: 11px" class="green-button"
                            >DETAY</span
                          ></a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../../services/http";
import NotesVue from "../PageBuilder/Notes.vue";
import EventBus from "./EventBus";

export default {
  props: ["title", "favorite", "nextLeadId"],
  name: "topsearch",
  data() {
    return {
      searchShow: false,
      searchValue: null,
      lead_id: 0,
      searchTable: "leads",
      searchResults: [],
      activeIndex: 0,
    };
  },
  mounted() {
    if (this.title) {
      document.title = this.title;
    }
    EventBus.$on("topSearchFocus", (data) => {
      this.searchShow = true;
      setTimeout(() => {
        document.getElementById("rootsearch").focus();
      }, 10);
    });
  },
  watch: {
    searchValue() {
      http.getSearchPhone({ keyword: this.searchValue }).then((resp) => {
        if (resp.data.success == true) {
          this.lead_id = 0;

          this.searchResults = resp.data.results;
          //  this.$forceUpdate();
        }
      });
    },
  },
  components: {
    Notes: NotesVue,
  },
  methods: {
    showSearchSet() {
      this.searchShow = true;
      setTimeout(() => {
        document.getElementById("rootsearch").focus();
      }, 100);
    },
    keyP(e) {
      if (e.key == "ArrowDown") {
        if (this.activeIndex < this.searchResults.length - 1) {
          this.activeIndex++;
        }
      } else {
        if (this.activeIndex > 0) {
          this.activeIndex--;
        }
      }
    },
    setLeadId(leadId) {
      EventBus.$emit("getNote");
      this.lead_id = leadId;
    },
    keyEnter() {
      this.searchSubmit();
    },
    boldla(e, k) {
      return e
        .toString()
        .toLowerCase()
        .replace(k.toLowerCase(), "<b>" + k.toLowerCase() + "</b>");
    },
    searchClear() {
      this.searchValue = "";
      this.searchSubmit();
    },

    favoriteAdd(favoriData) {
      http.addFavorite(favoriData).then((resp) => {
        EventBus.$emit("favoritesLoad");
      });
    },
    nextLead() {
      location.href = "/leadDetail/" + this.nextLeadId;

      //this.$router.push();
    },
    searchOnlyClear() {
      this.searchValue = "";
      this.searchShow = false;
      this.searchResults = null;
    },
    searchSubmit() {
      this.lead_id = 0;
      if (this.searchValue == null) {
        this.searchValue = "";
      }
      this.$router.push(
        "/list/" + this.searchTable + "/?name=" + this.searchValue,
        () => {}
      );
      this.searchShow = false;
    },
  },
};
</script>

<style></style>
